import React from 'react';
import { niceDateFormatter } from '../../../lib/helper/formatting';

/**
 * MED-921 - who this person is, read-only.
 *
 * Read-only is the specification, not a shortcut. `Patient` has no setters and the API exposes no
 * Post or Patch, because editing patient identity has to arrive with the audit position from
 * MED-961 already decided rather than inherit one by accident.
 *
 * Every field except the surname can be absent from the response - API Platform omits nulls, and
 * salutation is populated for nobody yet - so each one says what is missing rather than rendering
 * a gap the reader has to interpret.
 */
const notHeld = <span className="text-muted">Not held</span>;

class PatientIdentityCard extends React.Component {
  render() {
    const { patient } = this.props;

    return (
      <div className="crud__section mb-3 bg-white">
        <div className="crud__section-icon">
          <i className="fas fa-user" />
        </div>
        <h2 className="crud__section-header">Patient Details</h2>
        {/*<p className="text-muted mb-3">Identity is read-only in this release.</p>*/}

        <dl className="row mb-0">
          <dt className="col-sm-5">Salutation</dt>
          <dd className="col-sm-7">{patient.salutation || notHeld}</dd>

          <dt className="col-sm-5">First Name</dt>
          <dd className="col-sm-7">{patient.firstName || notHeld}</dd>

          <dt className="col-sm-5">Last Name</dt>
          <dd className="col-sm-7">{patient.lastName}</dd>

          <dt className="col-sm-5">Date of Birth</dt>
          <dd className="col-sm-7 mb-0">{patient.dateOfBirth ? niceDateFormatter(patient.dateOfBirth) : notHeld}</dd>
        </dl>
      </div>
    );
  }
}

export default PatientIdentityCard;
